import React from 'react';
import config from '../config.js';
// import { validateSysdump  }from '../libs/validateSysdump.js';
import FineUploaderS3 from 'fine-uploader-wrappers/s3';
import Gallery from 'react-fine-uploader';
import 'react-fine-uploader/gallery/gallery.css';

export default () => (
    <Gallery uploader={createFU()}/>
);

function createFU() {
    const pathArray = window.location.pathname.split( '/' );
    const token = pathArray[pathArray.length - 1];
    const apiGatewayURL = `${config.apiGateway.URL}/sign/${token}`;
    const uploader = new FineUploaderS3({
        options: {
            debug : false,
            // Chunking may throw warnings, which can be ignored.
            maxConnections : 9,
            chunking: {
                enabled: true,
                partSize: 50000000,
                concurrent: {
                    enabled: true
                }
            },
            resume: {
                enabled: false
            },
            deleteFile: {
                enabled: false,
                endpoint: apiGatewayURL
            },
            request: {
                endpoint: config.fineUploader.endpointURL,
                accessKey: config.fineUploader.endpointAccessKey
            },
            signature: {
                endpoint: apiGatewayURL,
                version: 4
            },
            validation: {
                allowedExtensions: ['tgz'],
                // sizeLimit: 4000000000
            },
            retry: {
                enableAuto: true
            },
            objectProperties: {
                region: config.fineUploader.endpointRegion,
                key: function (id) {
                    return token + '/' + this.getName(id);
                }
            },
            callbacks: {
                // File contents and corruption validation function - not yet implemented
                // onSubmit: function(id, name) {
                //     // var size = this.getSize(id);
                //     // var file = this.getFile(id);
                //     var validated = false;
                //     validated = validateSysdump(name);
                //     // return false;
                //     // return true;
                //     return validated;
                // },
                onError: function(id, name, errorReason, xhrOrXdr) {
                    alert(`Error on file ${name}.  Reason: ${errorReason}`);
                }
            },
            cors: {
                expected: true, //all requests are expected to be cross-domain requests
                sendCredentials: false, //if you want cookies to be sent along with the request
                allowXdr: true
            }
        }
    });
    // uploader.qq.xxx - this is the way to call qq properties
    return uploader;
}




// WEBPACK FOOTER //
// ./src/components/CustomFineUploader.js